import { render, staticRenderFns } from "./eventView.vue?vue&type=template&id=0b92dd45&scoped=true&xmlns=true"
import script from "./eventView.vue?vue&type=script&lang=js"
export * from "./eventView.vue?vue&type=script&lang=js"
import style0 from "./eventView.vue?vue&type=style&index=0&id=0b92dd45&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b92dd45",
  null
  
)

export default component.exports